// extracted by mini-css-extract-plugin
module.exports = {"Select":"Select_Select__143vT","Selector":"Select_Selector__LE1R8","theme-light":"Select_theme-light__3dJnT","theme-dark":"Select_theme-dark__-IgJE"};